<template>
  <v-app>
    <Banner />
    <Features />
    <Footer />
  </v-app>
</template>

<script>
import Banner from "../components/Home/Banner.vue";
import Features from "../components/Home/Features.vue";
import Footer from "../components/Home/Footer.vue";

export default {
  name: "Home",
  components: {
    Banner,
    Features,
    Footer
  },
  data(){
    return{
    }
  },

  metaInfo: {
    title: "The Smartest way to reward creativity",
    titleTemplate: "%s | Tippings ",
    meta: [
      {
        name: "description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      {
        property: "og:title",
        content: " A Smarter way to support creativity | Tippings"
      },
      { property: "og:site_name", content: "Tippings" },
      {
        property: "og:description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      { property: "og:type", content: "profile" },
      {
        property: "og:url",
        content: "https://tippings.me/"
      },
      { property: "og:image", content: "" }
    ]
  }
};
</script>

<style>
.menuLink {
  text-decoration: none;
  color: black !important;
  margin-left: 59px;
}
.menuLink:hover {
  border-bottom: solid 2px #e10712;
  color: #e10712 !important;
}
.active {
  border-bottom: solid 2px #e10712;
  color: #e10712 !important;
}
.menubar{
  position:fixed;
  top:0;
  left:0
}
</style>
